import styled from '@emotion/styled'
import { BackdropModal } from '@helpers/styles'
import type { Theme } from '@mui/material'

const BackdropWithModalStyles = styled(BackdropModal)`
	min-width: 500px;
`

const Header = styled.div`
	display: flex;
	flex-direction: column;
	padding: 20px;
	${({ theme }) => `
        border-bottom: 1px solid ${theme.palette.divider};
    `}
	margin-bottom: 24px;
`

const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0 20px;
	gap: 8px;
`

const Footer = styled.div`
	display: flex;
	justify-content: flex-end;
	${({ theme }: { theme: Theme }) => `
        border-top: 1px solid ${theme.palette.divider};
        gap: ${theme.spacing(2)};
    `}
	padding: 20px;
	width: 100%;
	margin-top: 24px;
`

export { BackdropWithModalStyles, ContentContainer, Footer, Header }
